<template>
  <div>
    <v-data-table
      id="tabela_listaGrupos"
      :headers="headers"
      :items="listaGrupoFornecedores"
      :no-data-text="$t('label.tabela_sem_conteudo')"
      :items-per-page="5"
      :footer-props="{
        itemsPerPageOptions: [5, 10, 25],
      }">

      <template v-slot:[`item.deletar`]="{ item }">
        <v-btn :disabled="item.desabilitaDeletar || somenteLeitura || desabilitarCadastroFornecedor"
          icon @click="removerLinhaGrupoFornecedor(item)">
          <v-icon>delete</v-icon>
        </v-btn>
      </template>

      <template v-slot:[`item.nomesCnpjsFormatados`]="{ item }">
        <div style="white-space: pre-wrap;">{{ item.nomesCnpjsFormatados }}</div>
      </template>
    </v-data-table>
  </div>
</template>

<script>
export default {
  name: 'UsuarioGrupoFornecedorList',
  props: {
    somenteLeitura: Boolean,
    desabilitarCadastroFornecedor: {
      type: Boolean,
      default: false,
    },
    listaGrupoFornecedores: {
      type: Array,
      default: () => ([]),
    },
  },
  data() {
    return {
      headers: [
        {
          text: '', value: 'deletar', sortable: false, align: 'center', width: '50px',
        },
        { text: this.$tc('label.grupo_fornecedor', 1), value: 'nomExtensao', sortable: true },
        { text: this.$tc('label.cnpj_tax_id', 1), value: 'nomesCnpjsFormatados', sortable: true },
      ],
    };
  },
  methods: {
    removerLinhaGrupoFornecedor(item) {
      const index = this.listaGrupoFornecedores.indexOf(item);
      if (index > -1) {
        this.listaGrupoFornecedores.splice(index, 1);
      }
    },
  },
};
</script>
